export const PARKING_STATION = "PARKING_STATION";
export const HOLDING_TRACKS = "HOLDING_TRACKS";
export const OTHER = "OTHER";
